import { z } from 'zod';

import { gql } from '~/utils/gql';

const WoolfUserCategorySchema = z.enum(['STUDY_TRACK', 'DEGREE']);
export type WoolfUserCategory = z.infer<typeof WoolfUserCategorySchema>;

export const woolfDegreeEnrollmentStatusSchema = z.enum([
  'PENDING',
  'ACTIVE',
  'REJECTED',
  'SUBMITTED',
  'COMPLETED',
  'ARCHIVED',
  'PAUSED',
]);
export type WoolfDegreeEnrollmentStatus = z.infer<typeof woolfDegreeEnrollmentStatusSchema>;

export const woolfUserSchema = z
  .object({
    data: z.object({
      user: z
        .object({
          woolfCategory: WoolfUserCategorySchema.nullable(),
          syncState: z.enum(['ACTIVE', 'PENDING', 'ARCHIVED', 'DISABLED']).nullable(),
          degreeEnrollments: z.array(
            z.object({
              status: woolfDegreeEnrollmentStatusSchema,
              degree: z.object({
                id: z.string(),
              }),
            })
          ),
        })
        .nullable(),
    }),
  })
  .transform(({ data }) => {
    return data.user;
  });

export type WoolfUser = z.infer<typeof woolfUserSchema>;

export const getWoolfUserQuery = gql`
  query GetUser($udacityId: ID!) {
    user(udacityId: $udacityId) {
      woolfCategory
      syncState
      degreeEnrollments {
        status
        degree {
          id
        }
      }
    }
  }
`;

export const woolfUserAgreeToTermsSchema = z
  .object({
    data: z.object({
      userAgreeToTerms: z.object({
        success: z.boolean(),
      }),
    }),
  })
  .transform(({ data }) => {
    return data.userAgreeToTerms.success;
  });

export type WoolfUserAgreeToTerms = z.infer<typeof woolfUserAgreeToTermsSchema>;

export const woolfUserAgreeToTermsMutation = gql`
  mutation UserAgreeToTerms($udacityId: ID!) {
    userAgreeToTerms(udacityId: $udacityId) {
      success
    }
  }
`;

export const woolfUserAddToWoolfMutation = gql`
  mutation UserAddToWoolf($input: UserAddToWoolfInput!) {
    userAddToWoolf(input: $input) {
      success
      user {
        woolfCategory
      }
    }
  }
`;

export const woolfUserAddToWoolfSchema = z
  .object({
    data: z.object({
      userAddToWoolf: z.object({
        success: z.boolean(),
        user: z.object({
          woolfCategory: WoolfUserCategorySchema,
        }),
      }),
    }),
  })
  .transform(({ data }) => {
    return data.userAddToWoolf;
  });

export type WoolfUserAddToWoolf = z.infer<typeof woolfUserAddToWoolfSchema>;
